import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _36ab29cc = () => interopDefault(import('../pages/zapis/success.vue' /* webpackChunkName: "pages/zapis/success" */))
const _fa0c3342 = () => interopDefault(import('../pages/zapis/error.vue' /* webpackChunkName: "pages/zapis/error" */))
const _2aaf40a4 = () => interopDefault(import('../pages/zapis/_slug/index.vue' /* webpackChunkName: "pages/zapis/_slug/index" */))
const _3f33c829 = () => interopDefault(import('../pages/zapis/index.vue' /* webpackChunkName: "pages/zapis/index" */))
const _05b29ffc = () => interopDefault(import('../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _4636bd91 = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _65a1b466 = () => interopDefault(import('../pages/vakansii/index.vue' /* webpackChunkName: "pages/vakansii/index" */))
const _799fa3c4 = () => interopDefault(import('../pages/uslugi/_slug/index.vue' /* webpackChunkName: "" */))
const _16750349 = () => interopDefault(import('../pages/uslugi/index.vue' /* webpackChunkName: "pages/uslugi/index" */))
const _1115e84c = () => interopDefault(import('../pages/stat/_category/_article/index.vue' /* webpackChunkName: "pages/stat/_category/_article/index" */))
const _6b5dd7a2 = () => interopDefault(import('../pages/stat/_category/index.vue' /* webpackChunkName: "pages/stat/_category/index" */))
const _492cd154 = () => interopDefault(import('../pages/stat/index.vue' /* webpackChunkName: "pages/stat/index" */))
const _9ac52480 = () => interopDefault(import('../pages/specialists/components/SpecialistCard.vue' /* webpackChunkName: "pages/specialists/components/SpecialistCard" */))
const _682b559e = () => interopDefault(import('../pages/specialists/components/Header/SpecialistHeader.vue' /* webpackChunkName: "pages/specialists/components/Header/SpecialistHeader" */))
const _112fb178 = () => interopDefault(import('../pages/specialists/index.vue' /* webpackChunkName: "" */))
const _e5fe5f68 = () => interopDefault(import('../pages/search/components/Articles.vue' /* webpackChunkName: "pages/search/components/Articles" */))
const _35957268 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _0628a765 = () => interopDefault(import('../pages/reviews/AddReviewModal.vue' /* webpackChunkName: "pages/reviews/AddReviewModal" */))
const _117adb1e = () => interopDefault(import('../pages/reviews/index.vue' /* webpackChunkName: "pages/reviews/index" */))
const _70fe0479 = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _9cd76532 = () => interopDefault(import('../pages/questions-specialist/_question/index.vue' /* webpackChunkName: "pages/questions-specialist/_question/index" */))
const _4b424a71 = () => interopDefault(import('../pages/questions-specialist/index.vue' /* webpackChunkName: "pages/questions-specialist/index" */))
const _2929b0c3 = () => interopDefault(import('../pages/profile/zapis/index.vue' /* webpackChunkName: "pages/profile/zapis/index" */))
const _15552978 = () => interopDefault(import('../pages/profile/my-acuvue/index.vue' /* webpackChunkName: "pages/profile/my-acuvue/index" */))
const _122629b0 = () => interopDefault(import('../pages/profile/edit/index.vue' /* webpackChunkName: "pages/profile/edit/index" */))
const _d20402c0 = () => interopDefault(import('../pages/profile/discount-card/get-card/index.vue' /* webpackChunkName: "pages/profile/discount-card/get-card/index" */))
const _64d57025 = () => interopDefault(import('../pages/profile/discount-card/_guid/index.vue' /* webpackChunkName: "pages/profile/discount-card/_guid/index" */))
const _76aa5f8c = () => interopDefault(import('../pages/profile/discount-card/index.vue' /* webpackChunkName: "pages/profile/discount-card/index" */))
const _d378083c = () => interopDefault(import('../pages/profile/certificates/index.vue' /* webpackChunkName: "pages/profile/certificates/index" */))
const _48ac62fd = () => interopDefault(import('../pages/profile/bonuses/index.vue' /* webpackChunkName: "pages/profile/bonuses/index" */))
const _1eb3e302 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _0e2426ef = () => interopDefault(import('../pages/product/test.vue' /* webpackChunkName: "pages/product/test" */))
const _43f2170f = () => interopDefault(import('../pages/product/glassesCardPage_v2.vue' /* webpackChunkName: "pages/product/glassesCardPage_v2" */))
const _65005e06 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _65bfe6f7 = () => interopDefault(import('../pages/checkout/success.vue' /* webpackChunkName: "" */))
const _338c501f = () => interopDefault(import('../pages/order/payment/cancel/_hash.vue' /* webpackChunkName: "pages/order/payment/cancel/_hash" */))
const _4d6a1d76 = () => interopDefault(import('../pages/order/payment/_hash.vue' /* webpackChunkName: "pages/order/payment/_hash" */))
const _a0c5a97e = () => interopDefault(import('../pages/checkout/process/_hash.vue' /* webpackChunkName: "" */))
const _3f66eb16 = () => interopDefault(import('../pages/ochki/_category/index.vue' /* webpackChunkName: "pages/ochki/_category/index" */))
const _1e443470 = () => interopDefault(import('../pages/ochki/index.vue' /* webpackChunkName: "pages/ochki/index" */))
const _05d303ca = () => interopDefault(import('../pages/miopiya/indexOriginal.vue' /* webpackChunkName: "pages/miopiya/indexOriginal" */))
const _07683360 = () => interopDefault(import('../pages/miopiya/components/QRList.vue' /* webpackChunkName: "pages/miopiya/components/QRList" */))
const _0030a4e8 = () => interopDefault(import('../pages/miopiya/components/MiopiyaReasons.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaReasons" */))
const _29a3e7e3 = () => interopDefault(import('../pages/miopiya/components/MiopiyaPrevention.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaPrevention" */))
const _18b7baac = () => interopDefault(import('../pages/miopiya/index.vue' /* webpackChunkName: "pages/miopiya/index" */))
const _88105b88 = () => interopDefault(import('../pages/lenses/competitors/_slug.vue' /* webpackChunkName: "pages/lenses/competitors/_slug" */))
const _0d01c63a = () => interopDefault(import('../pages/lenses/_category/index.vue' /* webpackChunkName: "pages/lenses/_category/index" */))
const _32d4c428 = () => interopDefault(import('../pages/lenses/index.vue' /* webpackChunkName: "pages/lenses/index" */))
const _eb9f8b9a = () => interopDefault(import('../pages/information_message/informationMessage.vue' /* webpackChunkName: "pages/information_message/informationMessage" */))
const _0a522740 = () => interopDefault(import('../pages/company/questions/page.vue' /* webpackChunkName: "pages/company/questions/page" */))
const _30326734 = () => interopDefault(import('../pages/company/questions/letterModal.vue' /* webpackChunkName: "pages/company/questions/letterModal" */))
const _8c38f0e4 = () => interopDefault(import('../pages/cms-page-preview/index.vue' /* webpackChunkName: "pages/cms-page-preview/index" */))
const _46646874 = () => interopDefault(import('../pages/checkout/process/new.vue' /* webpackChunkName: "pages/checkout/process/new" */))
const _7140dfa6 = () => interopDefault(import('../pages/checkout/process/index.vue' /* webpackChunkName: "pages/checkout/process/index" */))
const _5f7ed174 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _13161740 = () => interopDefault(import('../pages/charity/_category/_article/index.vue' /* webpackChunkName: "pages/charity/_category/_article/index" */))
const _1a8d417c = () => interopDefault(import('../pages/charity/_category/index.vue' /* webpackChunkName: "pages/charity/_category/index" */))
const _d7b838a4 = () => interopDefault(import('../pages/charity/index.vue' /* webpackChunkName: "pages/charity/index" */))
const _55be44c9 = () => interopDefault(import('../pages/catalog/components/SelectedFilter.vue' /* webpackChunkName: "pages/catalog/components/SelectedFilter" */))
const _5a4f6506 = () => interopDefault(import('../pages/catalog/components/FilterMobileComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterMobileComponent" */))
const _78b34e7f = () => interopDefault(import('../pages/catalog/components/FilterComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterComponent" */))
const _b7b856fe = () => interopDefault(import('../pages/catalog/components/ContactLinzCategory.vue' /* webpackChunkName: "pages/catalog/components/ContactLinzCategory" */))
const _395dcfc0 = () => interopDefault(import('../pages/catalog/components/ArticleCard.vue' /* webpackChunkName: "pages/catalog/components/ArticleCard" */))
const _3017ec7c = () => interopDefault(import('../pages/catalog/_.vue' /* webpackChunkName: "pages/catalog/_" */))
const _41b198ef = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _b5a2ad76 = () => interopDefault(import('../pages/cart_old.vue' /* webpackChunkName: "pages/cart_old" */))
const _27fad730 = () => interopDefault(import('../pages/cart/checkout.vue' /* webpackChunkName: "pages/cart/checkout" */))
const _6e74e2ec = () => interopDefault(import('../pages/cart-old/done.vue' /* webpackChunkName: "pages/cart-old/done" */))
const _7022e706 = () => interopDefault(import('../pages/cart-old/basketPageThirdStep.vue' /* webpackChunkName: "pages/cart-old/basketPageThirdStep" */))
const _0397aa3d = () => interopDefault(import('../pages/cart-old/basketPageSecondStep.vue' /* webpackChunkName: "pages/cart-old/basketPageSecondStep" */))
const _7f55f20c = () => interopDefault(import('../pages/cart-old/index.vue' /* webpackChunkName: "pages/cart-old/index" */))
const _0b3a91c0 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _671c3fb5 = () => interopDefault(import('../pages/bystraya-zapis/index.vue' /* webpackChunkName: "pages/bystraya-zapis/index" */))
const _15f38de2 = () => interopDefault(import('../pages/authorization/index.vue' /* webpackChunkName: "pages/authorization/index" */))
const _14d33f82 = () => interopDefault(import('../pages/appointment/appointment.vue' /* webpackChunkName: "pages/appointment/appointment" */))
const _8579d1f8 = () => interopDefault(import('../pages/aktsii/_slug/index.vue' /* webpackChunkName: "pages/aktsii/_slug/index" */))
const _2d0032ee = () => interopDefault(import('../pages/aktsii/index.vue' /* webpackChunkName: "pages/aktsii/index" */))
const _7b89826c = () => interopDefault(import('../pages/acuvue/phoneRegistrationForm.vue' /* webpackChunkName: "pages/acuvue/phoneRegistrationForm" */))
const _5e6731da = () => interopDefault(import('../pages/acuvue/index.vue' /* webpackChunkName: "pages/acuvue/index" */))
const _20fca8f2 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/zapis/success",
    component: _36ab29cc,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-success"
  }, {
    path: "/zapis/error",
    component: _fa0c3342,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-error"
  }, {
    path: "/zapis/:slug",
    component: _2aaf40a4,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-slug"
  }, {
    path: "/zapis",
    component: _3f33c829,
    pathToRegexpOptions: {"strict":true},
    name: "zapis"
  }, {
    path: "/wishlist",
    component: _05b29ffc,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist"
  }, {
    path: "/video",
    component: _4636bd91,
    pathToRegexpOptions: {"strict":true},
    name: "video"
  }, {
    path: "/vakansii",
    component: _65a1b466,
    pathToRegexpOptions: {"strict":true},
    name: "vakansii"
  }, {
    path: "/uslugi/:slug/:service",
    components: {
      default: _799fa3c4
    }
  }, {
    path: "/uslugi/:slug",
    component: _799fa3c4,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi-slug"
  }, {
    path: "/uslugi",
    component: _16750349,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi"
  }, {
    path: "/stat/:category/:article",
    component: _1115e84c,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category-article"
  }, {
    path: "/stat/:category",
    component: _6b5dd7a2,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category"
  }, {
    path: "/stat",
    component: _492cd154,
    pathToRegexpOptions: {"strict":true},
    name: "stat"
  }, {
    path: "/specialists/components/SpecialistCard",
    component: _9ac52480,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-SpecialistCard"
  }, {
    path: "/specialists/components/Header/SpecialistHeader",
    component: _682b559e,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-Header-SpecialistHeader"
  }, {
    path: "/specialists/:id",
    components: {
      default: _112fb178
    }
  }, {
    path: "/specialists",
    component: _112fb178,
    pathToRegexpOptions: {"strict":true},
    name: "specialists"
  }, {
    path: "/search/components/Articles",
    component: _e5fe5f68,
    pathToRegexpOptions: {"strict":true},
    name: "search-components-Articles"
  }, {
    path: "/search",
    component: _35957268,
    pathToRegexpOptions: {"strict":true},
    name: "search"
  }, {
    path: "/reviews/AddReviewModal",
    component: _0628a765,
    pathToRegexpOptions: {"strict":true},
    name: "reviews-AddReviewModal"
  }, {
    path: "/reviews",
    component: _117adb1e,
    pathToRegexpOptions: {"strict":true},
    name: "reviews"
  }, {
    path: "/registration",
    component: _70fe0479,
    pathToRegexpOptions: {"strict":true},
    name: "registration"
  }, {
    path: "/questions-specialist/:question",
    component: _9cd76532,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist-question"
  }, {
    path: "/questions-specialist",
    component: _4b424a71,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist"
  }, {
    path: "/profile/zapis",
    component: _2929b0c3,
    pathToRegexpOptions: {"strict":true},
    name: "profile-zapis"
  }, {
    path: "/profile/my-acuvue",
    component: _15552978,
    pathToRegexpOptions: {"strict":true},
    name: "profile-my-acuvue"
  }, {
    path: "/profile/edit",
    component: _122629b0,
    pathToRegexpOptions: {"strict":true},
    name: "profile-edit"
  }, {
    path: "/profile/discount-card/get-card",
    component: _d20402c0,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card-get-card"
  }, {
    path: "/profile/discount-card/:guid",
    component: _64d57025,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card-guid"
  }, {
    path: "/profile/discount-card",
    component: _76aa5f8c,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card"
  }, {
    path: "/profile/certificates",
    component: _d378083c,
    pathToRegexpOptions: {"strict":true},
    name: "profile-certificates"
  }, {
    path: "/profile/bonuses",
    component: _48ac62fd,
    pathToRegexpOptions: {"strict":true},
    name: "profile-bonuses"
  }, {
    path: "/profile",
    component: _1eb3e302,
    pathToRegexpOptions: {"strict":true},
    name: "profile"
  }, {
    path: "/product/test",
    component: _0e2426ef,
    pathToRegexpOptions: {"strict":true},
    name: "product-test"
  }, {
    path: "/product/glassesCardPage_v2",
    component: _43f2170f,
    pathToRegexpOptions: {"strict":true},
    name: "product-glassesCardPage_v2"
  }, {
    path: "/product/:slug?",
    component: _65005e06,
    pathToRegexpOptions: {"strict":true},
    name: "product-slug"
  }, {
    path: "/order/success/:hash",
    components: {
      default: _65bfe6f7
    }
  }, {
    path: "/order/payment/cancel/:hash?",
    component: _338c501f,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-cancel-hash"
  }, {
    path: "/order/payment/:hash?",
    component: _4d6a1d76,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-hash"
  }, {
    path: "/order/:hash",
    components: {
      default: _a0c5a97e
    }
  }, {
    path: "/ochki/:category",
    component: _3f66eb16,
    pathToRegexpOptions: {"strict":true},
    name: "ochki-category"
  }, {
    path: "/ochki",
    component: _1e443470,
    pathToRegexpOptions: {"strict":true},
    name: "ochki"
  }, {
    path: "/miopiya/indexOriginal",
    component: _05d303ca,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-indexOriginal"
  }, {
    path: "/miopiya/components/QRList",
    component: _07683360,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-QRList"
  }, {
    path: "/miopiya/components/MiopiyaReasons",
    component: _0030a4e8,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaReasons"
  }, {
    path: "/miopiya/components/MiopiyaPrevention",
    component: _29a3e7e3,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaPrevention"
  }, {
    path: "/miopiya",
    component: _18b7baac,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya"
  }, {
    path: "/lenses/competitors/:slug?",
    component: _88105b88,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-competitors-slug"
  }, {
    path: "/lenses/:category",
    component: _0d01c63a,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-category"
  }, {
    path: "/lenses",
    component: _32d4c428,
    pathToRegexpOptions: {"strict":true},
    name: "lenses"
  }, {
    path: "/information_message/informationMessage",
    component: _eb9f8b9a,
    pathToRegexpOptions: {"strict":true},
    name: "information_message-informationMessage"
  }, {
    path: "/company/questions/page",
    component: _0a522740,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-page"
  }, {
    path: "/company/questions/letterModal",
    component: _30326734,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-letterModal"
  }, {
    path: "/cms-page-preview",
    component: _8c38f0e4,
    pathToRegexpOptions: {"strict":true},
    name: "cms-page-preview"
  }, {
    path: "/checkout/success",
    component: _65bfe6f7,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-success"
  }, {
    path: "/checkout/process/new",
    component: _46646874,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-new"
  }, {
    path: "/checkout/process/:hash",
    component: _a0c5a97e,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-hash"
  }, {
    path: "/checkout/process",
    component: _7140dfa6,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process"
  }, {
    path: "/checkout",
    component: _5f7ed174,
    pathToRegexpOptions: {"strict":true},
    name: "checkout"
  }, {
    path: "/charity/:category/:article",
    component: _13161740,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category-article"
  }, {
    path: "/charity/:category",
    component: _1a8d417c,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category"
  }, {
    path: "/charity",
    component: _d7b838a4,
    pathToRegexpOptions: {"strict":true},
    name: "charity"
  }, {
    path: "/catalog/components/SelectedFilter",
    component: _55be44c9,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-SelectedFilter"
  }, {
    path: "/catalog/components/FilterMobileComponent",
    component: _5a4f6506,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterMobileComponent"
  }, {
    path: "/catalog/components/FilterComponent",
    component: _78b34e7f,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterComponent"
  }, {
    path: "/catalog/components/ContactLinzCategory",
    component: _b7b856fe,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ContactLinzCategory"
  }, {
    path: "/catalog/components/ArticleCard",
    component: _395dcfc0,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ArticleCard"
  }, {
    path: "/catalog/*",
    component: _3017ec7c,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-all"
  }, {
    path: "/catalog",
    component: _41b198ef,
    pathToRegexpOptions: {"strict":true},
    name: "catalog"
  }, {
    path: "/cart_old",
    component: _b5a2ad76,
    pathToRegexpOptions: {"strict":true},
    name: "cart_old"
  }, {
    path: "/cart/checkout",
    component: _27fad730,
    pathToRegexpOptions: {"strict":true},
    name: "cart-checkout"
  }, {
    path: "/cart-old/done",
    component: _6e74e2ec,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-done"
  }, {
    path: "/cart-old/basketPageThirdStep",
    component: _7022e706,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageThirdStep"
  }, {
    path: "/cart-old/basketPageSecondStep",
    component: _0397aa3d,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageSecondStep"
  }, {
    path: "/cart-old",
    component: _7f55f20c,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old"
  }, {
    path: "/cart",
    component: _0b3a91c0,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/bystraya-zapis",
    component: _671c3fb5,
    pathToRegexpOptions: {"strict":true},
    name: "bystraya-zapis"
  }, {
    path: "/authorization",
    component: _15f38de2,
    pathToRegexpOptions: {"strict":true},
    name: "authorization"
  }, {
    path: "/appointment/appointment",
    component: _14d33f82,
    pathToRegexpOptions: {"strict":true},
    name: "appointment-appointment"
  }, {
    path: "/aktsii/:slug",
    component: _8579d1f8,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii-slug"
  }, {
    path: "/aktsii",
    component: _2d0032ee,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii"
  }, {
    path: "/acuvue/phoneRegistrationForm",
    component: _7b89826c,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue-phoneRegistrationForm"
  }, {
    path: "/acuvue",
    component: _5e6731da,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue"
  }, {
    path: "/*",
    component: _20fca8f2,
    pathToRegexpOptions: {"strict":true},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
